export interface PagingResultGq {
  amountPerPage: number;
  page: number;
  count: number;
}

export const PagingResultGq = `
  amountPerPage
  page
  count
`;
